import { StakeholderOrder, StakeholderSortBy } from '../../types/stakeholder.types';
import { localStorageUtil } from '../../utils/local-storage.util';

export const stakeholdersSortStore = localStorageUtil<{
  field: null | StakeholderSortBy;
  sortMode: null | StakeholderOrder;
}>('stakeholdersSortState');
